// 三方在线客服（kefu.muye.club）弹窗接入
// 不加载三方 ai_service_diy_*.js（其自带悬浮条、5 秒后自动弹聊天窗、且覆写 window.onload），
// 直接以 iframe 内嵌三方聊天页（与其官方脚本行为一致）：桌面端 /layer。
// business_id 为商家号，需与服务商开通的账号一致（当前为占位，开通后确认修改）。

const KEFU_BASE = 'https://kefu.muye.club'
const KEFU_BUSINESS_ID = '136'
const KEFU_THEME = '13c9cb' // 三方 style1 默认主题色
const KEFU_WINDOW_ID = 'third-party-kefu-window'
const KEFU_STYLE_ID = 'third-party-kefu-style'

function buildKefuUrl(user) {
  const u = user || {}
  const qs = [
    'theme=' + KEFU_THEME,
    'visiter_id=' + encodeURIComponent(u.uid ? String(u.uid) : ''),
    'visiter_name=' + encodeURIComponent(u.nickname || u.email || ''),
    'avatar=' + encodeURIComponent(u.avatar || ''),
    'business_id=' + KEFU_BUSINESS_ID,
    'groupid=0',
    'product=' + encodeURIComponent('{}')
  ].join('&')
  return KEFU_BASE + '/layer?' + qs
}

function ensureKefuWindowStyle() {
  if (document.getElementById(KEFU_STYLE_ID)) return
  const style = document.createElement('style')
  style.id = KEFU_STYLE_ID
  style.textContent = [
    '#' + KEFU_WINDOW_ID + ' { position: fixed; right: 24px; bottom: 24px; z-index: 9999; display: none; flex-direction: column;',
    '  width: 380px; height: 560px; max-width: calc(100vw - 32px); max-height: calc(100vh - 48px);',
    '  background: #1a1a2e; border: 1px solid rgba(255,204,0,.3); border-radius: 10px;',
    '  box-shadow: 0 8px 30px rgba(0,0,0,.45); overflow: hidden; }',
    '#' + KEFU_WINDOW_ID + ' .tpk-header { display: flex; align-items: center; justify-content: space-between;',
    '  padding: 10px 14px; background: #16213e; color: #ffcc00; font-size: 14px; font-weight: 700; }',
    '#' + KEFU_WINDOW_ID + ' .tpk-close { cursor: pointer; font-size: 20px; line-height: 1; color: #888; }',
    '#' + KEFU_WINDOW_ID + ' .tpk-close:hover { color: #fff; }',
    '#' + KEFU_WINDOW_ID + ' .tpk-iframe { flex: 1; width: 100%; border: 0; background: #fff; }'
  ].join('\n')
  document.head.appendChild(style)
}

// 打开三方客服聊天窗（每次打开都会按当前登录态刷新 visiter 参数）
export function openThirdPartyKefu(user) {
  if (typeof document === 'undefined') return
  ensureKefuWindowStyle()
  let win = document.getElementById(KEFU_WINDOW_ID)
  if (!win) {
    win = document.createElement('div')
    win.id = KEFU_WINDOW_ID
    win.innerHTML =
      '<div class="tpk-header"><span class="tpk-title">在线客服</span><span class="tpk-close">&times;</span></div>' +
      '<iframe class="tpk-iframe"></iframe>'
    win.querySelector('.tpk-close').addEventListener('click', closeThirdPartyKefu)
    document.body.appendChild(win)
  }
  const url = buildKefuUrl(user)
  const iframe = win.querySelector('.tpk-iframe')
  if (iframe.getAttribute('src') !== url) iframe.setAttribute('src', url)
  win.style.display = 'flex'
}

export function closeThirdPartyKefu() {
  if (typeof document === 'undefined') return
  const win = document.getElementById(KEFU_WINDOW_ID)
  if (win) win.style.display = 'none'
}
